import SideNav from '../../components/SideNavBar/SideNavBar';
import React, { useContext, useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import Dashborad from '../../pages/Dashboard/Dashboard';
import UserProfile from '../../pages/Profile/UserProfile';
import DematDetails from '../../pages/Profile/DematDetails/DematDetails';
import IPOListing from '../../pages/IPOSubscription/IPOListing';
import Transactions from '../../pages/Transactions/Transaction';
import IPOIndex from '../IPOSubscription/IPOindex';
import {CreateDematPage} from '../Profile/CreateDemat/CreateDematPage';
import ErrorComponent from '../ErrorComponent/ErrorComponent';
import Referal from '../Referal/Referal';
import { Context } from '../../services/apiContext';

const Home = () => {
  const [allowRefer, setAllowRefer] = useState();
  const contextapi = useContext(Context);

  useEffect(() => {
    if (contextapi.getSession('cseData')) {
      setAllowRefer(false);
    } else {
      setAllowRefer(true);
    }
  });

  return (
    <div className='container-fluid mx-auto paddingZeroSidenav'>
      <div className='row marginAuto'>
        <div className='col-lg-2 col-md-8 hidmob'>
          <SideNav></SideNav>
        </div>
        <div className='col-lg-10 col-md-12 px-0 pt-3 mt-md-2'>
          <div id='content'>
            <Routes>
              <Route path='dashboard' element={<Dashborad />} />

              <Route
                path='UserProfile'
                element={<UserProfile isfromDashBoard={true} />}
              />
              {allowRefer && (
                <Route
                  path='referral'
                  element={<Referal isfromDashBoard={true} />}
                />
              )}
              <Route path='createDemat' element={<CreateDematPage />} />
              <Route path='IPO/*' element={<IPOIndex />} />
              {/* */}
              <Route path='*' exact={true} element={<ErrorComponent />} />
            </Routes>
          </div>
        </div>
      </div>
    </div>
  );
};

//

export default Home;
